import React, { useState } from 'react';
import { clsx } from 'clsx';
import { Lock, Eye, EyeOff } from 'lucide-react';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  showLockIcon?: boolean;
  containerClassName?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  error,
  hint,
  showLockIcon = true,
  containerClassName,
  className,
  id,
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={clsx('form-group', containerClassName)}>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <div className="relative">
        {showLockIcon && <Lock className="form-icon form-icon-left" />}
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          className={clsx(
            'form-input form-input-action',
            showLockIcon && 'form-input-icon',
            error && 'form-input-error',
            className
          )}
          {...props}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="form-action"
          aria-label={visible ? 'Hide password' : 'Show password'}
          tabIndex={-1}
        >
          {visible ? <EyeOff /> : <Eye />}
        </button>
      </div>
      {error ? (
        <p className="form-error">{error}</p>
      ) : (
        hint && <p className="form-hint">{hint}</p>
      )}
    </div>
  );
};
